import React from "react";
import {
  TextInput,
  Edit,
  SimpleForm,
  Title,
  useNotify,
  useUpdate,
  DateInput,
  BooleanInput,
} from "react-admin";
import Box from "@mui/material/Box";
import { uploadBase64Media } from "../../dataprovider/uploadProps";
import ImageInputWithCrop from "../../components/ImageInputWithCrop";

export default (props) => {
  const EventTitle = () => "Event Details";
  const notify = useNotify();
  const [update] = useUpdate();

  const save = async (data) => {
    let imageUrl = data.image;
    try {
      if (data.image) {
        imageUrl = await uploadBase64Media(data.image, "event");
      }
    } catch (error) {
      notify("File is too large. max allowed size (100kb)", { type: "warning" });
      return;
    }
    await update(
      "events",
      { id: data.id, data: { ...data, image: imageUrl } },
      { returnPromise: true }
    )
      .then(() => {
        notify("Event Updated");
      })
      .catch((err) => {
        console.error(err);
        notify("Something wrong happened. please try again", { type: "warning" });
      });
  };
  return (
    <>
      <Title title="" />
      <Edit {...props} redirect="" mutationMode="optimistic" title={<EventTitle />}>
        <SimpleForm onSubmit={save} sx={{ maxWidth: 500 }}>
          <TextInput source="name" fullWidth helperText={false} />
          <Box display={{ xs: "block", sm: "flex", width: "100%" }} sx={{ mt: 2 }}>
            <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
              <DateInput source="fromDate" label="From" fullWidth />
            </Box>
            <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
              <DateInput source="toDate" label="To" fullWidth />
            </Box>
          </Box>
          <ImageInputWithCrop source="image" label="Sponsor Image" aspect="3/2" />

          <TextInput source="url" label="Event URL" fullWidth helperText={false} />

          <Box display={{ xs: "block", sm: "flex", width: "100%" }} sx={{ mt: 2 }}>
            <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
              <BooleanInput source="activate" label="Show Event" fullWidth />
            </Box>
            <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
              <BooleanInput source="allowRegistrations" fullWidth />
            </Box>
          </Box>
        </SimpleForm>
      </Edit>
    </>
  );
};
